(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.routes')
		.config(routes);

	/** @ngInject */
	function routes($stateProvider, $locationProvider, PATHS, $urlRouterProvider) {
		$locationProvider.html5Mode(true);
		$urlRouterProvider.otherwise('/nao-encontrado');

		$stateProvider
			.state('app', {
				abstract: true,
				templateUrl: `${PATHS.PHYSICAL}/components/layout/layout.html`,
				onEnter: ($rootScope, HelperService) => {
					$rootScope.hideLoading = true;
				}
			})

			.state('app.home', {
				title: 'Cupons',
				url: '/',
				templateUrl: `${PATHS.PHYSICAL}/components/homepage/homepage.html`,
				controller: 'HomepageController',
				controllerAs: 'vm'
			})

			.state('app.login', {
				title: 'Login',
				url: '/login',
				templateUrl: `${PATHS.PHYSICAL}/components/login/login.html`,
				controller: 'LoginController',
				controllerAs: 'vm'
			})

			.state('app.forgot-password', {
				title: 'Esqueci minha senha',
				url: '/esqueci-minha-senha',
				templateUrl: `${PATHS.PHYSICAL}/components/forgot-password/forgot-password.html`,
				controller: 'ForgotPasswordController',
				controllerAs: 'vm'
			})

			.state('app.oauth2callback', {
				title: 'Autenticação',
				url: '/oauth2callback/{provider}',
				templateUrl: `${PATHS.PHYSICAL}/components/oauth2callback/oauth2callback.html`,
				controller: 'OAuth2CallbackController',
				controllerAs: 'vm'
			})

			.state('app.register', {
				title: 'Cadastre-se',
				url: '/register',
				templateUrl: `${PATHS.PHYSICAL}/components/register/register.html`,
				controller: 'RegisterController',
				controllerAs: 'vm'
			})

			.state('app.privacy', {
				title: 'Política de Privacidade',
				url: '/politica-de-privacidade',
				templateUrl: `${PATHS.PHYSICAL}/components/privacy/privacy.html`,
				controller: 'RegisterController',
				controllerAs: 'vm'
			})

			.state('app.not-found', {
				title: 'Não encontrado',
				url: '/nao-encontrado',
				templateUrl: `${PATHS.PHYSICAL}/components/common/not-found.html`,
				controller: 'HomepageController',
				controllerAs: 'vm'
			})
	}
}());